// @flow
import React from 'react';
import path from 'ramda/es/path';
import prop from 'ramda/es/prop';
import { useTranslation } from 'react-i18next';

import type { TariffType, Sub } from 'app/components/Tariff/Tariff';
import Periods from 'app/components/Tariff/Periods';
import AvailableInformers from 'app/components/Tariff/AvailableInformers';
import Options from 'app/components/Tariff/InformsPacks/Options';

import styles from './InformsStandartSms.scss';


type Props = {
  subId?: number,
  sub: Sub,
  tariff: TariffType,
  footnotes: Object,
  studentId: number,
}

const InformsStandartSms = ({
  subId,
  sub,
  tariff,
  footnotes,
  studentId,
}: Props) => {
  const isFree = !!(sub && sub.test_days_left);
  const { t } = useTranslation('tariff');

  return (
    <div>
      <div className={styles.row}>
        <div className={styles.col}>
          <div>{`${t('informs_title')}:`}</div>
          <AvailableInformers
            tariff={tariff}
            footnotes={footnotes}
            over={{ sms: false }}
          />
        </div>
        <div className={styles.col}>
          <Periods
            header={`${t('available_subscriptions')}:`}
            subId={subId}
            periods={path(['month_daily_params', 'periods'], tariff)}
            paid={!!prop('prepaid_stop_at', sub)}
            isSms={false}
            isFree={isFree}
            locked={prop('is_paused', sub)}
            studentId={studentId}
            tariffId={!tariff.inside ? tariff.id : undefined}
            tariffBundleId={tariff.inside ? tariff.id : undefined}
          />
        </div>
      </div>
      <Options
        inside={[tariff]}
        subId={subId}
        sub={sub}
        footnotes={footnotes}
        overrideTitle={t('sms_notification')}
      />
    </div>
  );
};

export default InformsStandartSms;
